import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SettingsManagementComponent} from './setting-management/settings-management.component';
import {LibraryConfigComponent} from "./library-config/library-config.component";

const routes: Routes = [
  {
    path: 'compliance/settings',
    component: SettingsManagementComponent
  },
  {
    path: 'compliance/library-configuration',
    component: LibraryConfigComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SettingsRoutingModule {
}
